import { useEffect, useRef, useState } from 'react';
import {
	buildProductMedia3dMetricDetail,
	watchAndAttachProductMedia3dViewerListeners,
} from '../utils/product-media-3d-viewer-mount.js';

/**
 * @param {string} modelUrl
 * @returns {{
 *   hasViewerLoadError: boolean,
 *   normalizedModelUrl: string,
 *   viewerContainerRef: import('react').RefObject<HTMLDivElement | null>,
 * }}
 */
export function useProductMedia3dViewerMount(modelUrl) {
	const normalizedModelUrl = typeof modelUrl === 'string' ? modelUrl.trim() : '';
	const viewerContainerRef = useRef(null);
	const [hasViewerLoadError, setHasViewerLoadError] = useState(false);

	useEffect(() => {
		setHasViewerLoadError(false);
	}, [normalizedModelUrl]);

	useEffect(() => {
		if (normalizedModelUrl === '') {
			return undefined;
		}

		const containerElement = viewerContainerRef.current;
		if (containerElement === null) {
			return undefined;
		}

		const metricDetail = buildProductMedia3dMetricDetail(normalizedModelUrl);
		let cancelled = false;

		const cleanup = watchAndAttachProductMedia3dViewerListeners(
			containerElement,
			metricDetail,
			() => cancelled,
			{ onViewerLoadFailed: () => setHasViewerLoadError(true) },
		);

		return () => {
			cancelled = true;
			cleanup();
		};
	}, [normalizedModelUrl]);

	return {
		hasViewerLoadError,
		normalizedModelUrl,
		viewerContainerRef,
	};
}
